import { defineReactiveModel, Persistable } from "vue-app-utils";
import Model from "@/models/model";

const ReadonlyProfile = {
  extends: Model,
  mixins: [
    Persistable
  ]
};

export default defineReactiveModel(ReadonlyProfile);
